export default "__VITE_ASSET__2MZNUza1__"